import "./EmailTemplate.scss";
import React, { useState, useEffect, useMemo, useRef } from "react";
import api_call from "../../../globals/common_utilities/axios_old";
import { API, APP_ROUTES, FOMRS } from "../../../globals/constants/index";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import InputField from "../../../components/common/InputField";
import Button from "../../../components/common/Button";
import Dropdown from "../../../components/common/Dropdown";
import EmailTemplateEditor from "../../../components/EmailTemplateEditor";
import Stack from "@mui/material/Stack";
import { Grid, Typography } from "@mui/material";
import BoldTag from "../../../Images/bold-tag.svg";
import ItalicTag from "../../../Images/italic-tag.svg";
import UnderlineTag from "../../../Images/underline-tag.svg";
import StrikeTag from "../../../Images/strike-tag.svg";
import ImageIcon from "../../../Images/image-wrapper.svg";
import FontSizeIcon from "../../../Images/number-icon.svg";
import HtmlIcon from "../../../Images/html-tag.svg";
import HighlighterIcon from "../../../Images/pen-icon.svg";
import AlignIcon from "../../../Images/indent-icon.svg";
import BulletIcon from "../../../Images/bullet-icon.svg";
import NumberingIcon from "../../../Images/numbering-icon.svg";
import CONSTANTURL from "../../../globals/common_utilities/constanturls";
import Cookies from "universal-cookie";
import JoditEditor from "jodit-react";
import { isEmpty, FORM_VALIDATION } from "../../../globals/constants";

function EmailTemplate() {
  const editor = useRef(null);
  const navigate = useNavigate();
  const { state } = useLocation();
  const { loginResponse, loading, error } = useSelector((state) => {
    return state.login;
  });
  const initialContent = `<p style ="font-size: 18px">Dear @student_name,</p>
<p style ="font-size: 18px">Welcome to @training_name sessions conducted in @training_center_name by @instructor_name From @training_start_date to @training_end_date.</p>
<p style = "font-size: 18px">Find the below schedule:</p>
                                                               <table style="border-collapse:collapse;width: 100%;">
                                                                  <tbody>
                                                                      <tr>
                                                                          <td style="width: 16.6667%;font-size: 18px;">@Schedules<br></td>
                                                                          <td style="width: 16.6667%;font-size: 18px; ">@start_dates<br></td>
                                                                          <td style="width: 16.6667%;font-size: 18px;">@end_dates<br></td>
                                                                          <td style="width: 16.6667%;font-size: 18px;">@start_time<br></td>
                                                                          <td style="width: 16.6667%;font-size: 18px;">@end_time<br></td>
                                                                          <td style="width: 16.6667%;font-size: 18px;">@Day's<br></td>
                                                                      </tr>
                                                                          <tr>
                                                                          <td style="width: 16.6667%;font-size: 18px;">@schedule<br></td>
                                                                          <td style="width: 16.6667%;font-size: 18px;">@session_start_date<br></td>
                                                                          <td style="width: 16.6667%;font-size: 18px;">@session_end_date<br></td>
                                                                          <td style="width: 16.6667%;font-size: 18px;">@session_start_time<br></td>
                                                                          <td style="width: 16.6667%;font-size: 18px;">@session_end_time<br></td>
                                                                          <td style="width: 16.6667%;font-size: 18px;">@session_days<br></td>
                                                                      </tr>
                                                                  </tbody>
                                                              </table>
  <p>&nbsp; <br></p>
<p style="font-size: 18px;">Information about your virtual machines will be sent separately 30 mins before the class begins. </p>
<p style="font-size: 18px;">Meeting Invite Link</p>
<p style="font-size: 18px;">EULA, Terms and conditions</p>
<p style="font-size: 18px;">By accessing this online training, I am agreeing to the Epic Games Terms of Service(<a href='https://www.epicgames.com/site/en-US/tos'>https://www.epicgames.com/site/en-US/tos</a>) and understand that my data will be used in accordance with the&nbsp; Epic&nbsp; Games Privacy Policy (<a href='https://www.epicgames.com'>https://www.epicgames.com</a>)`.trim();
  const cookies = new Cookies();

  const {
    id,
    name,
    device_id,
    studio_id,
    role_id,
    role_code,
    token,
    token_uniq_id,
    email_id,
    username,
    is_email_verify,
  } = cookies.get("loginData");
  console.log("ID ", id, " Name ", name, " studio id ", studio_id);
  const [formField, setFormField] = useState({
    template_name: "",
    template_type: "",
    language: "",
    mail_body: "",
  });
  const [formField_error, setFormFild_error] = useState({
    template_name_error: false,
    template_type_error: false,
    language_error: false,
    mail_body_error: false,
  });
  // Drop Down
  const [templateTypeList, setTemplateTypeList] = useState([
    {
      label: "Invite Mail",
      value: "Invite Mail",
      id: "1",
    },
    {
      label: "Welcome Mail",
      value: "Welcome Mail",
      id: "2",
    },
  ]);
  const chk_initialcontent = (
    <input type="text" required={true} readOnly={true} value="John" />
  );

  const [templateType, setTemplateType] = useState("");
  const [type, setType] = useState();
  const [data, setData] = useState(initialContent);
  const [userDetails, setUserDetails] = useState();
  const handleChange = (selected) => {
    setTemplateType(selected);
  };
  // Template Type
  const on_template_type = (e) => {
    setFormField({ ...formField, template_type: e.value });
    setFormFild_error({
      ...formField_error,
      template_type_error: false,
    });
  };
  console.log("Form Fields :: ", formField);

  const getToster = (res) => {
    console.log("Inside Toaster");
    if (res.status === 200) {
      toast.success(
        `${
          state?.action === "edit"
            ? "Email Template Updated Successfully"
            : "Email Template Created Successfully"
        }`,
        {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        }
      );
    } else if (res.status === 409) {
      toast.error(`Email template name already taken `, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    }
  };
  // Suggestions
  const names = [
    "@mary",
    "@jain",
    "@entany",
    "@isaak",
    "@ivan",
    "@fedya",
    "@yakov",
    "@jhon",
    "@lena",
    "@elvin",
  ];

  const config = useMemo(
    () => ({
      readonly: false, // all options from https://xdsoft.net/jodit/doc/
      iframe: true,
      // enter: false,
      useInputsPlaceholder: true,
      // textIcons: true,
      style: {
        color: "white",
        fontFamily: "Eurostile Extended",
        background: "#141623",
      },
      // sizeLG: 900,
      // sizeMD: 700,
      // sizeSM: 474,
      placeholder: "",
      toolbarButtonSize: "large",
      uploader: {
        insertImageAsBase64URI: true,
      },
      createAttributes: {
        div: {
          class: "align-center",
        },
      },
      autocomplete: {
        sources: [names],
      },
      buttons: [
        {
          iconURL: HighlighterIcon,
          name: "brush",
          tooltip: "Add Color",
        },
        "|",
        {
          iconURL: BoldTag,
          name: "bold",
          tooltip: "Bold",
        },
        {
          iconURL: ItalicTag,
          name: "italic",
          tooltip: "Italic",
        },
        {
          iconURL: UnderlineTag,
          name: "underline",
          tooltip: "Underline",
        },
        {
          iconURL: AlignIcon,
          name: "align",
          tooltip: "Add Indent",
        },
      ],
    }),
    []
  );
  // Drop Down Styling
  // API Call
  const onSubmit = async () => {
    if (!isValid()) {
      const str_replace = data.replace(
        `<table style="border-collapse:collapse;width: 100%;">`,
        ""
      );
      const str_replace1 = str_replace.replace(`<tbody>`, "");
      const str_replace2 = str_replace1.replace(`<tr>`, "");
      const str_replace3 = str_replace2.replace(
        `<td style="width: 16.6667%;font-size: 18px;">@Schedules<br></td>`,
        ""
      );
      const str_replace4 = str_replace3.replace(
        `<td style="width: 16.6667%;font-size: 18px; ">@start_dates<br></td>`,
        ""
      );
      const str_replace5 = str_replace4.replace(
        `<td style="width: 16.6667%;font-size: 18px;">@end_dates<br></td>`,
        ""
      );
      const str_replace6 = str_replace5.replace(
        `<td style="width: 16.6667%;font-size: 18px;">@start_time<br></td>`,
        ""
      );
      const str_replace7 = str_replace6.replace(
        `<td style="width: 16.6667%;font-size: 18px;">@end_time<br></td>`,
        ""
      );
      const str_replace8 = str_replace7.replace(
        `<td style="width: 16.6667%;font-size: 18px;">@Day's<br></td>`,
        ""
      );
      const str_replace9 = str_replace8.replace(`</tr>`, "");
      const str_replace10 = str_replace9.replace(`<tr>`, "");
      const str_replace11 = str_replace10.replace(
        `<td style="width: 16.6667%;font-size: 18px;">@schedule<br></td>`,
        ""
      );
      const str_replace12 = str_replace11.replace(
        `<td style="width: 16.6667%;font-size: 18px;">@session_start_date<br></td>`,
        ""
      );
      const str_replace13 = str_replace12.replace(
        `<td style="width: 16.6667%;font-size: 18px;">@session_end_date<br></td>`,
        ""
      );
      const str_replace14 = str_replace13.replace(
        `<td style="width: 16.6667%;font-size: 18px;">@session_start_time<br></td>`,
        ""
      );
      const str_replace15 = str_replace14.replace(
        `<td style="width: 16.6667%;font-size: 18px;">@session_end_time<br></td>`,
        ""
      );
      const str_replace16 = str_replace15.replace(
        `<td style="width: 16.6667%;font-size: 18px;">@session_days<br></td>`,
        ""
      );
      const str_replace17 = str_replace16.replace(`</tr>`, "");
      const str_replace18 = str_replace17.replace(` </tbody>`, "");
      const str_replace19 = str_replace18.replace(`</table>`, "@schedules");
      const str_replace20 = str_replace19.replace("/n", "");
      console.log("cxgcggggg", str_replace20);
      let str_data = str_replace20.split("@schedules");

      let mail_body = str_data[0]
        .trim()
        .concat("\n@schedules")
        .concat(str_data[1]);
      console.log("sdjgdsgjsjsgsgdjhgjhsd", mail_body);
      let bodyParam = {
        template_name: formField.template_name,
        template_type: formField.template_type,
        language: formField.language,
        mail_body: mail_body,
        created_by: id,
        updated_by: id,
        studio_id: studio_id,
        studio_template: role_code === "STUDIO_ADMIN" ? true : false,
      };

      console.log("Body Param ", bodyParam);

      if (state?.action === "edit") {
        let response = "";
        response = await api_call(
          "POST",
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
            API.END_POINTS.EMAIL_TEMPLATE,
          { update_id: state?.id },
          {},
          bodyParam
        );
        console.log("API Response ", response);
        if (response.status === 200) {
          getToster(response);
          navigate(APP_ROUTES.ROUTE_EMAILTEMPLATELIST);
        } else if (response.status === 400) {
          console.log("Inside 400 code");
          getToster(response?.err?.data?.msg1);
        } else if (response.status === 409) {
          getToster(response);
        }
      } else {
        let response = "";
        response = await api_call(
          "POST",
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
            API.END_POINTS.EMAIL_TEMPLATE,
          {},
          {},
          bodyParam
        );
        console.log("API Response ", response);
        if (response.status === 200) {
          getToster(response);
          navigate(APP_ROUTES.ROUTE_EMAILTEMPLATELIST);
        } else if (response.status === 400) {
          console.log("Inside 400 code");
          getToster(response?.err?.data?.msg1);
        } else if (response.status === 409) {
          getToster(response);
        }
      }
    }
  };
  const gotolistingPage = () => {
    console.log("Inside Go to Listing Page");
    navigate(APP_ROUTES.ROUTE_EMAILTEMPLATELIST, {
      state: {},
    });
  };
  const isValid = () => {
    let error = false;
    let chk_valid = data.match(new RegExp(/^[\w\d\s] @student_name+/));
    let abc = data.replaceAll("<p>", "");
    let efg = abc.replaceAll("<p", "");
    let ghi = efg.replaceAll("</p>", "");
    let ghh = ghi.replaceAll("<table", "");
    let vvc = ghh.replaceAll(">", "");
    let bjg = vvc.replaceAll("<tbody", "");
    let beg = bjg.replaceAll("<tr", "");
    let vxv = beg.replaceAll("</tr", "");
    let ssf = vxv.replaceAll("</tr", "");
    let ghd = ssf.replaceAll("<td", "");
    let gjj = ghd.replaceAll("</td", "");
    let fhk = gjj.replaceAll("<br", "");
    let remove_tag = fhk.replaceAll("</tbody", "");
    let remove_tag3 = remove_tag.replaceAll("<span", "");
    let remove_tag4 = remove_tag3.replaceAll("</span", "");
    let remove_tag2 = remove_tag4.replaceAll("</table", "");

    console.log(
      "gjhsgjgsdgsd",
      FORM_VALIDATION.SCRIPT.test(formField?.template_name)
    );

    if (formField?.template_name === "") {
      toast.error(`Please add template name`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!FORM_VALIDATION.SCRIPT.test(formField?.template_name)) {
      toast.error(`Please add valid template name`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (formField?.template_name.trim().length == 0) {
      toast.error(`Please add valid template name`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (remove_tag2.includes("&lt")) {
      toast.error(`Invalid data`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (remove_tag2.includes("&gt")) {
      toast.error(`Invalid data`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@student_name")) {
      toast.error(`Missing @student_name`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@training_name sessions")) {
      toast.error(`Missing @training_name`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@training_center_name")) {
      toast.error(`Missing @training_center_name`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@instructor_name")) {
      toast.error(`Missing @instructor_name`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@training_start_date")) {
      toast.error(`Missing @training_start_date`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@training_end_date")) {
      toast.error(`Missing @training_end_date`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@Schedules")) {
      toast.error(`Missing @Schedules`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@start_dates")) {
      toast.error(`Missing @start_date`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@end_dates")) {
      toast.error(`Missing @start_date`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@start_time")) {
      toast.error(`Missing @start_time`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@end_time")) {
      toast.error(`Missing @end_time`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@Day's")) {
      toast.error(`Missing @Day's`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@schedule")) {
      toast.error(`Missing @schedule`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@session_start_date")) {
      toast.error(`Missing @session_start_date`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@session_end_date")) {
      toast.error(`Missing @session_end_date`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    } else if (!remove_tag2.includes("@session_start_time")) {
      toast.error(`Missing @session_start_time`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@session_end_time")) {
      toast.error(`Missing @session_end_time`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@session_end_time")) {
      toast.error(`Missing @session_end_time`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("@session_days")) {
      toast.error(`Missing @session_days`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (
      !remove_tag2.includes(
        "Information about your virtual machines will be sent separately 30 mins before the class begins."
      )
    ) {
      toast.error(
        `Missing "Information about your virtual machines will be sent separately 30 mins before the class begins."`,
        {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        }
      );
      error = true;
    } else if (!remove_tag2.includes("Meeting Invite Link")) {
      toast.error(`Missing "Meeting Invite Link"`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    } else if (!remove_tag2.includes("EULA, Terms and conditions")) {
      toast.error(`Missing "EULA, Terms and conditions"`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      error = true;
    }
    return error;
  };
  const TemplateById = async () => {
    const response = await api_call(
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
        API.END_POINTS.GET_EMAIL_BY_ID,
      {
        id: state?.id,
        studio_id: studio_id,
      }
    );
    console.log("################### ", response);
    if (response.status === 200) {
      console.log("jkhjgjhuduhj---", response.data.data.rows[0]);
      await setUserDetails(response?.data?.data?.rows[0]);
      console.log("User Details ", userDetails);
      let replace_string = response.data.data.rows[0].mail_body.replaceAll(
        "@schedules",
        `  <table style="border-collapse:collapse;width: 100%;">
        <tbody>
            <tr>
                <td style="width: 16.6667%;font-size: 18px;">@Schedules<br></td>
                <td style="width: 16.6667%;font-size: 18px; ">@start_dates<br></td>
                <td style="width: 16.6667%;font-size: 18px;">@end_dates<br></td>
                <td style="width: 16.6667%;font-size: 18px;">@start_time<br></td>
                <td style="width: 16.6667%;font-size: 18px;">@end_time<br></td>
                <td style="width: 16.6667%;font-size: 18px;">@Day's<br></td>
            </tr>
                <tr>
                <td style="width: 16.6667%;font-size: 18px;">@schedule<br></td>
                <td style="width: 16.6667%;font-size: 18px;">@session_start_date<br></td>
                <td style="width: 16.6667%;font-size: 18px;">@session_end_date<br></td>
                <td style="width: 16.6667%;font-size: 18px;">@session_start_time<br></td>
                <td style="width: 16.6667%;font-size: 18px;">@session_end_time<br></td>
                <td style="width: 16.6667%;font-size: 18px;">@session_days<br></td>
            </tr>
        </tbody>
    </table>`
      );
      setData(replace_string);
      console.log("DATaaaaaaaaaaaaa >>>>>>>>>>>>. ", data);
      console.log(
        "check the response-0n9",
        response?.data?.data?.rows[0]?.template_name
      );
      setFormField({
        template_name: response.data.data.rows[0].template_name,
      });
    }
  };
  useEffect(() => {
    console.log("chk_initialcontent()", chk_initialcontent);
  }, [chk_initialcontent]);
  useEffect(() => {
    if (state?.id) {
      TemplateById();
    }
    console.log("Inside useEffect ", state?.action);
    setType(state?.action ? state?.action : "add");
  }, []);
  useEffect(() => {
    console.log("check the name of template", formField?.template_name);
  }, [formField?.template_name]);

  return (
    <>
      {console.log("Type ", type)}
      <Stack spacing={5} className="emailContent">
        <Breadcrumbs className="email_title" separator=">>" aria-label="h3">
          <span className="larger_f_bold" onClick={gotolistingPage}>
            {" "}
            {`Email Template`}
          </span>

          <span className="larger_f_bold_title">
            {state?.action === "info"
              ? "View Email Template"
              : state?.action === "edit"
              ? "Edit Email Template"
              : "Create Email Template"}
          </span>
        </Breadcrumbs>
        <Stack className="emailForm">
          <Grid
            container
            className="email_form_body"
            rowSpacing={3}
            columnSpacing={3}
          >
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <Typography className="FieldHeading" variant="h6">
                Template Name
              </Typography>
              <InputField
                type="text"
                value={formField?.template_name}
                placeholder="Template Name"
                className="Input_Field"
                disabled={state?.action === "info" ? true : false}
                onChange={(e) => {
                  setFormField({
                    ...formField,
                    template_name: e.target.value,
                  });
                  setFormFild_error({
                    ...formField_error,
                    template_name_error: false,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <Typography
                className="FieldHeading"
                variant="h6"
                style={{ marginTop: "40px" }}
              >
                Note: Please do not edit/remove words starting with " @"
              </Typography>
            </Grid>
            {/* <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <Typography className="FieldHeading" variant="h6">
                Template Language
              </Typography>

              <InputField
                type="text"
                placeholder="English"
                className="Input_Field"
                onChange={(e) => {
                  setFormField({
                    ...formField,
                    language: e.target.value,
                  });
                  setFormFild_error({
                    ...formField_error,
                    language_error: false,
                  });
                }}
              />
            </Grid> */}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              {/* <EmailTemplateEditor
								className="email_editor"
								// config={config}
								// onChange={(e) => {
								// 	setFormField({
								// 		...formField,
								// 		mail_body: e,
								// 	});
								// 	setFormFild_error({
								// 		...formField_error,
								// 		mail_body_error: false,
								// 	});
								// }}
								// initialContent={initialContent}
							/> */}
              <JoditEditor
                ref={editor}
                config={config}
                className="email_editor"
                value={data}
                // onChange={async(value) => await setData(value)}
                onBlur={(value) => setData(value)}
                // onChange={(e) => {
                //   setFormField({
                //     ...formField,
                //     mail_body: e,
                //   });
                //   setFormFild_error({
                //     ...formField_error,
                //     mail_body_error: false,
                //   });
                // }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
            {type === "add" && (
              <Button
                className="create_btn"
                value={"Create Template"}
                role="primary"
                onClick={() => onSubmit()}
                // onClick={() => isValid()}
                // // isValid
              ></Button>
            )}
            {state?.action === "edit" && (
              <Button
                className="create_btn"
                value={"Update Template"}
                role="primary"
                onClick={() => onSubmit()}
                // onClick={() => isValid()}
                // // isValid
              ></Button>
            )}
            {state?.action === "info" && ""}
          </Grid>
        </Stack>
      </Stack>
    </>
  );
}

export default EmailTemplate;
